exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Button__button___2a549 {\n    display: table;\n    background: #ff8e42;\n    color: white;\n    border-radius: 0;\n    padding: 10px 20px;\n    font-weight: 300;\n    border: 0;\n    font-size: 1rem;\n}\n\n.Button__button___2a549:hover {\n    color: white;\n    background: #ce7133;\n}\n\n.Button__light___3xQhP {\n    background: transparent;\n    color: #ff8e42;\n    border: 2px solid #ff8e42;\n}\n\n.Button__light___3xQhP:hover {\n    background: #ff8e42;\n}\n\n.Button__inline___2OESK {\n    display: inline-block;\n    margin-right: 20px;\n}\n\n.Button__center___2v4sc {\n    margin: 40px auto 0;\n}\n\n.Button__pullRight___2X8l2 {\n    float: right;\n}\n\n.Button__goBack___3XFvB {\n    padding: 0;\n    background: none;\n    color: grey;\n    line-height: 48px;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.Button__goBack___3XFvB:hover {\n    color: grey;\n    text-decoration: underline;\n}\n\n.Button__goBack___3XFvB svg {\n    margin-right: 15px;\n}\n", ""]);

// exports
exports.locals = {
	"button": "Button__button___2a549",
	"light": "Button__light___3xQhP",
	"inline": "Button__inline___2OESK",
	"center": "Button__center___2v4sc",
	"pullRight": "Button__pullRight___2X8l2",
	"goBack": "Button__goBack___3XFvB"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Button/Button.css
// module id = 359
// module chunks = 0